// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"b03c5436","81":"2e9ad510","140":"f8f96857","352":"a88454b7","420":"3098169f","457":"755e15e5","684":"b348bf3a"}[chunkId] + ".chunk.js";
};